export default __webpack_public_path__ + "media/Healthcare.0fd165aa.svg";